import { render, staticRenderFns } from "./tableRadio.vue?vue&type=template&id=270a4792&scoped=true&"
import script from "./tableRadio.vue?vue&type=script&lang=js&"
export * from "./tableRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a4792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270a4792')) {
      api.createRecord('270a4792', component.options)
    } else {
      api.reload('270a4792', component.options)
    }
    module.hot.accept("./tableRadio.vue?vue&type=template&id=270a4792&scoped=true&", function () {
      api.rerender('270a4792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableRadio.vue"
export default component.exports